"use strict";
/**
 * The GHE-rate-limit-aware-scanning budget-state + deferred-unit ledger
 * contract (spec #842, TASK-3 — "the budget-state and deferred-ledger
 * contracts, defined once"). Both record shapes, the availability
 * discriminator, and the contract version stamp live here ONCE so the writer
 * (TASK-9: repo-discovery / repo-scanner) and the reader (TASK-12, sibling
 * slice #843) cannot drift — the classic "constants declared once, imported
 * by every side" rule (constitution: shared cross-lambda constants), the same
 * discipline `GheResponseClass` already applies in `ghe-resilience.ts` for the
 * response-classification vocabulary.
 *
 * The key builders for both rows (`gheBudgetKey`, `gheDeferredUnitKey`) live
 * in `@sdd-maturity/lambda-utils/budget-keys` — NOT here — because
 * `lambda-utils` deliberately keeps zero dependency on this package (see
 * `budget-keys.ts`'s module doc). This package owns only the record shapes;
 * both rows are singleton-shaped rows on the EXISTING `scores` table (NFR-2 —
 * no new table, stream, or always-on infrastructure) and are TTL-free by
 * design: the budget-state row is a durable running total (never expires),
 * and the deferred-unit ledger row is "outstanding work" cleared explicitly
 * on success (AC-5.4), not an audit log that ages out.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GHE_BUDGET_CONTRACT_VERSION = void 0;
/**
 * The current contract version — stamped on every write by every producer
 * (TASK-9) and checked by every consumer (TASK-12) that needs to reason about
 * shape. Bump this (and add the new literal to {@link GheBudgetContractVersion})
 * the same way `CURRENT_RUBRIC_VERSION` is bumped in `rubric.ts`, whenever
 * either record's shape changes in a way a reader must know about.
 */
exports.GHE_BUDGET_CONTRACT_VERSION = 'v1';
//# sourceMappingURL=ghe-budget.js.map